import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatChipsModule } from "@angular/material/chips";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { FlexModule } from "@vp/shared/directives/flex";
import { FormSanitizerModule } from "@vp/shared/directives/form-sanitizer";
import { AddRecipientsDialogComponent } from "./add-recipients-dialog.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormSanitizerModule,
    FlexModule,
    MatChipsModule,
    MatIconModule
  ],
  declarations: [AddRecipientsDialogComponent],
  exports: [AddRecipientsDialogComponent]
})
export class AddRecipientsDialogModule {}
